import { tickerWords } from '@/mocks/home';

function Ticker() {
  const loop = [...tickerWords, ...tickerWords];

  return (
    <div className="w-full bg-primary-600 text-background-50 overflow-hidden">
      <div className="flex items-center gap-4 py-3">
        <span className="shrink-0 pl-4 md:pl-8 flex items-center gap-2 text-xs font-medium whitespace-nowrap">
          <i className="ri-fire-line text-base"></i>
          热词追踪
        </span>
        <span className="w-px h-4 bg-background-50/30 shrink-0"></span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex items-center gap-8 whitespace-nowrap w-max">
            {loop.map((word, index) => (
              <span
                key={`${word}-${index}`}
                className="flex items-center gap-8 text-xs md:text-sm text-background-50/90"
              >
                {word}
                <i className="ri-circle-fill text-[5px] text-background-50/50"></i>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ticker;